module.exports = __webpack_public_path__ + "media/images/flags/32/Mauritius-09f5ba042de6b8767c97977ccae77a13.png";